module.exports = __webpack_public_path__ + "static/Adobe_Desktop_Hover-a3768ad08a2e2421be40a2ea9adbb5c6.jpg";